import { render } from "./CalculatorPersonAdditional.vue?vue&type=template&id=0a7eef66"
import script from "./CalculatorPersonAdditional.vue?vue&type=script&lang=js"
export * from "./CalculatorPersonAdditional.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__